export const TOOLBOX_ITEMS = [
    {name: 'Projects Owners', path: `/admin/project-owners`},
    {name: 'Projects', path: `/admin/projects`},
    {name: 'AR Content', path: `/admin/arcontent`},
    {name: 'Tags', path: `/admin/tags`},
    {name: 'Categories', path: `/admin/categories`},
    {name: 'Cities', path: `/admin/cities`},
    {name: 'Countries', path: `/admin/countries`},
]